import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { RelationshipProduct } from "@thos/Services/ThosApiModels";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    overrideReplacementTitle = "overrideReplacementTitle",
    overrideSupersederTitle = "overrideSupersederTitle",
}

export interface OwnProps extends WidgetProps {
    fields: {
        [fields.overrideReplacementTitle]: string;
        [fields.overrideSupersederTitle]: string;
    };
}

type Props = OwnProps & WidgetProps & HasProduct;

export interface ProductDetailsRelationshipStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    productLink?: LinkPresentationProps;
}

export const relationshipStyles: ProductDetailsRelationshipStyles = {
    labelText: {
        size: 16,
        weight: "normal",
        css: css`
            margin-bottom: 5px;
            display: inline-block;
        `,
    },
    valueText: {
        size: 16,
        weight: "bold",
        css: css`
        `,
    },
    productLink: {
        typographyProps: {
            underline: true,
        }
    },
};

const styles = relationshipStyles;

const ProductDetailsRelationship: React.FC<Props> = ({ product, fields }) => {
    if (!product.properties.productRelationship) {
        return null;
    }
    const relationshipProducts = JSON.parse(product.properties?.altProducts);
    
    return (
        <Typography {...styles.valueText} as="p" data-test-selector="ProductDetailsRelationship">
            {product.properties.productRelationship === "Superseder Products" && (
                <Typography {...styles.labelText}>{fields.overrideSupersederTitle ? fields.overrideSupersederTitle : product.properties.productRelationship}</Typography>
            )}
            {product.properties.productRelationship === "Replacement Products" && (
                <Typography {...styles.labelText}>{fields.overrideReplacementTitle ? fields.overrideReplacementTitle : product.properties.productRelationship}</Typography>
            )}
            {relationshipProducts && (
                relationshipProducts.map((product: RelationshipProduct) => (
                    <StyledWrapper key={product.brandName}>
                        <Link href={`/Product/${product.link}`} {...styles.productLink}>
                            {product.brandName}{product.manufactureNumber && (`: ${product.manufactureNumber}`)}
                        </Link>
                    </StyledWrapper>
                ))
            )}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsRelationship),
    definition: {
        displayName: "Relationship",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        fieldDefinitions: [
            {
                name: fields.overrideReplacementTitle,
                displayName: "Override Replacement Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.overrideSupersederTitle,
                displayName: "Override Superseder Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
